export const AVATAR_EMOTIONS = ['neutral', 'happy', 'sad'] as const
export type AvatarEmotion = typeof AVATAR_EMOTIONS[number]

// Studio video-gen uses a v-prefixed route; enable only after service registration.
export const EMOTION_PIPELINES: Record<AvatarEmotion, string> = {
  neutral: 'v1.14.1.5',
  happy: 'v1.14.1.6',
  sad: 'v1.14.1.4',
}

// Feature-flag-off compatibility for new preprocess tasks, which no longer
// recommend a video-gen pipeline. Existing tasks may still carry their value.
export const LEGACY_STUDIO_PIPELINE = 'v7.7.1.1'

export function normalizeAvatarEmotion(value: unknown): AvatarEmotion {
  return AVATAR_EMOTIONS.includes(value as AvatarEmotion) ? value as AvatarEmotion : 'neutral'
}
